import {
  fireEvent,
  hideChatbot,
  setMetadata,
  setOnMessage,
  setOpen,
  showChatbot,
  subscribeToEvent,
  trackEvent,
  unsubscribeFromEvent,
} from '../../api';
import {
  injectChatElement,
  injectScript,
  isChatElementMounted,
  removeChatbotScript,
  removeChatElement,
} from '../../dom';
import type { ChatbotEventKey, ChatbotLogger, ChatEventCallback } from '../../types';
import type { ChatbotVendorAdapter } from '../types';

/** Applied Labs adapter (default vendor) — delegates to the existing Applied Labs wrappers. */
export const appliedAdapter: ChatbotVendorAdapter = {
  injectScript: (logger) => injectScript(logger),
  injectElement: (config, logger) => injectChatElement(config, logger),
  removeElement: (logger) => removeChatElement(logger),
  removeScript: (logger) => removeChatbotScript(logger),
  isMounted: () => isChatElementMounted(),
  setMetadata: (metadata, logger) => setMetadata(metadata, logger),
  show: (logger) => showChatbot(logger),
  hide: (logger) => hideChatbot(logger),
  setOpen: (open, logger) => setOpen(open, logger),
  setOnMessage: (callback, logger) => setOnMessage(callback, logger),
  subscribeToEvent: <T>(
    event: ChatbotEventKey,
    callback: ChatEventCallback<T>,
    logger: ChatbotLogger | Console,
  ) => subscribeToEvent<T>(event, callback, logger),
  unsubscribeFromEvent: (id, logger) => unsubscribeFromEvent(id, logger),
  fireEvent: (event, payload, logger) => fireEvent(event, payload, logger),
  trackEvent: (event, value, meta, logger) => trackEvent(event, value, meta, logger),
};
